export const languages = [
  { label: 'English (en)', value: 'en' },
  { label: 'Hrvatski (hr)', value: 'hr' },
  { label: 'Українська (ua)', value: 'ua' },
];
